export const VogoIcon = () => (
  <svg
    width="91"
    height="35"
    viewBox="0 0 91 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.42537 0.890137H0L11.8759 34.1248H17.9467L18.1318 33.607C15.972 31.2129 14.9428 28.0617 14.8783 24.5439C14.7101 24.1517 13.9377 22.3395 13.4268 20.9639L6.42537 0.890137ZM18.7826 14.1207C18.8051 14.0994 18.8277 14.0782 18.8504 14.0571C20.8522 12.1917 23.422 11.0948 26.3339 10.6534L29.8226 0.890137H23.3972L18.7826 14.1207ZM25.0989 14.1094C20.5078 15.4086 18.0022 18.9363 18.0022 24.1883C18.0022 26.4962 18.4797 28.4651 19.3998 30.0585L25.0989 14.1094Z"
      fill="#111926"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M68.0986 14.691H73.8432C74.2433 11.7003 76.1264 10.0838 79.5229 10.0838C83.3781 10.0838 85.2836 12.1665 85.2836 15.9774C85.2836 19.7883 83.3781 21.871 79.5229 21.871C79.2329 21.871 78.9539 21.8592 78.6859 21.8358V26.5953C78.96 26.6068 79.2391 26.6125 79.5229 26.6125C86.8345 26.6125 90.9999 22.7573 90.9999 15.9774C90.9999 9.24184 86.8345 5.34231 79.5229 5.34231C72.6486 5.34231 68.5994 8.74786 68.0986 14.691Z"
      fill="#F84B5C"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M60.1325 0C48.8327 0 43.072 6.20381 43.072 17.0605C43.072 27.9171 48.8327 34.121 58.6259 34.121C65.4057 34.121 69.7927 30.7089 71.388 25.1697L72.806 25.5242C71.8311 27.7399 71.4323 29.2022 71.4323 31.6837V33.3233H76.3067V17.5922H60.5756V22.378H68.5963C67.4884 26.5434 64.032 28.6262 59.4235 28.6262C52.9538 28.6262 49.4974 24.7709 49.4974 17.0605C49.4974 9.35003 52.9538 5.45049 60.1325 5.45049C63.5368 5.45049 66.0177 6.79868 67.4917 8.49355C68.3988 6.97752 69.6977 5.27117 71.3713 3.89773C68.8088 1.61093 65.0626 0 60.1325 0Z"
      fill="#FAC800"
    />
    <path
      d="M18.002 24.1886C18.002 17.453 22.1231 13.5535 29.479 13.5535C36.7906 13.5535 40.956 17.453 40.956 24.1886C40.956 30.9684 36.7906 34.8237 29.479 34.8237C22.1231 34.8237 18.002 30.9684 18.002 24.1886ZM23.7183 24.1886C23.7183 27.9995 25.6238 30.0822 29.479 30.0822C33.3342 30.0822 35.2397 27.9995 35.2397 24.1886C35.2397 20.3777 33.3342 18.295 29.479 18.295C25.6238 18.295 23.7183 20.3777 23.7183 24.1886Z"
      fill="#111926"
    />
  </svg>
);
